import React from "react";
import styled, { css } from "styled-components";
import { Database } from "react-feather";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { rawColors } from "../../../design-system/tokens/colors";
import { borderRadius } from "../../../design-system/tokens/borders";

export interface SchemaListItemProps {
  name: string;
  /** Optional badge — selected-table count for this schema. Omit when 0. */
  count?: number;
  active?: boolean;
  onClick?: () => void;
}

const Row = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  width: 100%;
  padding: ${spacing[2]} ${spacing[3]};
  background-color: ${({ $active }) =>
    $active ? rawColors.primary[100] : "transparent"};
  border: none;
  border-radius: ${borderRadius.md};
  cursor: pointer;
  text-align: left;
  ${typographyMixin("body", 4)}
  color: ${({ $active }) =>
    $active ? rawColors.primary[500] : rawColors.text.highEmphasis};

  ${({ $active }) =>
    !$active &&
    css`
      &:hover {
        background-color: ${rawColors.stroke[100]};
      }
    `}
`;

const Icon = styled(Database)`
  width: 16px;
  height: 16px;
  color: ${rawColors.text.mediumEmphasis};
  flex: 0 0 auto;
`;

const Name = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Count = styled.span`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.primary[500]};
  flex: 0 0 auto;
`;

export const SchemaListItem: React.FC<SchemaListItemProps> = ({
  name,
  count,
  active = false,
  onClick,
}) => (
  <Row type="button" $active={active} onClick={onClick} aria-pressed={active}>
    <Icon aria-hidden="true" />
    <Name>{name}</Name>
    {count && count > 0 ? <Count>{count}</Count> : null}
  </Row>
);

export default SchemaListItem;
